export const typeButtonsData = [
  {
    image: {
      height: 283,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/1e7ad508-105e-447a-b3c6-016205eb1981.jpg',
      width: 500,
      name: 'TỔNG THỂ',
    },
    objects: [
      {
        id: '67e26c01d10d75c7dcedf2f1',
        coordinates: [0.10986514817218784, 0.10431376422315759],
      },
      {
        id: '67e26c0dd10d75c7dcedf2fa',
        coordinates: [0.538435813303259, 0.1056707723118667],
      },
      {
        id: '67e26bf6d10d75c7dcedf2e8',
        coordinates: [0.8365897967769083, 0.363001133739727],
      },
      {
        id: '67e26be9d10d75c7dcedf2df',
        coordinates: [0.6932059942255453, 0.40456965733610795],
      },
      {
        id: '67e26bded10d75c7dcedf2d6',
        coordinates: [0.5184569848660716, 0.5055217860701758],
      },
    ],
  },

  {
    image: {
      height: 524,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/c39733c5-34c9-4dd2-88ae-5a7d0f20c405.jpg',
      width: 925,
      name: 'TẦNG 3',
    },
    objects: [
      {
        id: '67e61346ead9d8bd5fae6876',
        coordinates: [0.5231504093687516, 0.43959952161703664],
      },
      {
        id: '67e61351ead9d8bd5fae687f',
        coordinates: [0.34745005702371784, 0.46198944495237304],
      },
      {
        id: '67e6133cead9d8bd5fae686d',
        coordinates: [0.3230517397150084, 0.18037068941984982],
      },
    ],
  },

  {
    image: {
      height: 645,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/386d31ab-216a-4f98-bb18-8f2f8f755ce2.jpg',
      width: 1140,
      name: 'TẦNG 1',
    },
    objects: [
      {
        id: '67e61358ead9d8bd5fae6888',
        coordinates: [0.21287708158934252, 0.3702951645813435],
      },
      {
        id: '67e61331ead9d8bd5fae669d',
        coordinates: [0.1800590912250987, 0.750226138313369],
      },
      {
        id: '67e26a81d10d75c7dcedf25f',
        coordinates: [0.3506707702843742, 0.11783830209363819],
      },
      {
        id: '67e26ad2d10d75c7dcedf29f',
        coordinates: [0.390315965589095, 0.4245521813303985],
      },
      {
        id: '67e26ac6d10d75c7dcedf296',
        coordinates: [0.4634487914548328, 0.40555453383972523],
      },
      {
        id: '67e26ae4d10d75c7dcedf2b1',
        coordinates: [0.4634487914548328, 0.2942825985372103],
      },
      {
        id: '67e26adbd10d75c7dcedf2a8',
        coordinates: [0.3880736472645815, 0.3008130081300813],
      },
      {
        id: '67e26aadd10d75c7dcedf284',
        coordinates: [0.6215985273894908, 0.36655443002797444],
      },
      {
        id: '67e26aa2d10d75c7dcedf27a',
        coordinates: [0.9397263199054504, 0.426336304998328],
      },
      {
        id: '67e26abdd10d75c7dcedf28d',
        coordinates: [0.5628720995699518, 0.34552845528455284],
      },
      {
        id: '67e26a8ad10d75c7dcedf268',
        coordinates: [0.3848310036491646, 0.717658742615072],
      },
      {
        id: '67e26a6fd10d75c7dcedf24b',
        coordinates: [0.9104731895591553, 0.14196846730151116],
      },
      {
        id: '67e61311ead9d8bd5fae6682',
        coordinates: [0.036754331803328974, 0.5183802898737914],
      },
      {
        id: '67e6131eead9d8bd5fae668b',
        coordinates: [0.03272719384878274, 0.6797825773256435],
      },
      {
        id: '67e6132aead9d8bd5fae6694',
        coordinates: [0.3396669882509291, 0.6848385407811381],
      },
      {
        id: '67e26a65d10d75c7dcedf242',
        coordinates: [0.5557789841103268, 0.24860640643781745],
      },
      {
        id: '67e26a76d10d75c7dcedf256',
        coordinates: [0.3589253681670279, 0.5303360148702249],
      },
      {
        id: '67e6135dead9d8bd5fae6896',
        coordinates: [0.2144126057687874, 0.48970902793031057],
      },
      {
        id: '67e26a94d10d75c7dcedf271',
        coordinates: [0.1157440302443026, 0.8989757500047707],
      },
    ],
  },
];
